import accessibility from '../Images/icons/Accessibility.png'
import airQuality from '../Images/icons/Air Quality.png'
import energyEfficiency from '../Images/icons/Energy Efficiency.png'
import fireSafety from '../Images/icons/Fire Safety.png'
import immediateAttention from '../Images/icons/Immediate Attention.png'
import lifeSafety from '../Images/icons/Life Safety.png'
import pestManagement from '../Images/icons/Pest Management.png'
import sanitation from '../Images/icons/Sanitation.png'
import stairHazard from '../Images/icons/Stair Hazard.png'
import structural from '../Images/icons/Structural.png'
import tripAndFallHazard from '../Images/icons/Trip-and-Fall Hazard.png'
import waterConservation from '../Images/icons/Water Conservation.png'
import waterIntrusion from '../Images/icons/Water Intrusion.png'

import vendor from '../Images/icons/Vendor.png'
import buildingAwareness from '../Images/icons/Building Awareness.png'
import daily from '../Images/icons/Daily.png'
import weekly from '../Images/icons/Weekly.png'
import monthly from '../Images/icons/Monthly.png'
import quarterly from '../Images/icons/Quarterly.png'
import semiAnnual from '../Images/icons/Semi-Annual.png'
import seasonal from '../Images/icons/Seasonal.png'
import annual from '../Images/icons/Annual.png'
import every2Years from '../Images/icons/Every2Years.png'
import every5Years from '../Images/icons/Every5Years.png'
import every10Years from '../Images/icons/Every10Years.png'

import allIcons from '../Images/icons/icons_all.png'

window._ms_testImage = waterIntrusion

/*
Vendor.png
Building Awareness.png
Daily.png
Weekly.png
Monthly.png
Quarterly.png
Semi-Annual.png
Seasonal.png
Annual.png
Every_2_years.png
Every_5_years.png
Every_10_years.png
*/

const allSingles = {
  accessibility,
  airQuality,
  energyEfficiency,
  fireSafety,
  immediateAttention,
  lifeSafety,
  pestManagement,
  sanitation,
  stairHazard,
  structural,
  tripAndFallHazard,
  waterConservation,
  waterIntrusion,
  vendor,
  buildingAwareness,
  daily,
  weekly,
  monthly,
  quarterly,
  semiAnnual,
  seasonal,
  annual,
  every2Years,
  every5Years,
  every10Years,
}

let all = {}
const singleIconWidth = 601
;[
  'accessibility',
  'airQuality',
  'energyEfficiency',
  'fireSafety',
  'immediateAttention',
  'lifeSafety',
  'pestManagement',
  'sanitation',
  'stairHazard',
  'structural',
  'tripAndFallHazard',
  'waterConservation',
  'waterIntrusion',
  'vendor',
  'buildingAwareness',
  'daily',
  'weekly',
  'monthly',
  'quarterly',
  'semiAnnual',
  'seasonal',
  'annual',
  'every2Years',
  'every5Years',
  'every10Years',
].forEach((icon, idx, items) => {
  let len = items.length * singleIconWidth
  all[icon] = {
    offset: len - (idx * singleIconWidth),
    image: allIcons,
    single: allSingles[icon],
  }
})




let reportIcons = [
  {...all.accessibility, _name:'Accessibility', _mask:'Accessibility'},
  {...all.airQuality, _name:'Air Quality', _mask:'Air Quality'},
  {...all.energyEfficiency, _name:'Energy Efficiency', _mask:'Energy Efficiency'},
  {...all.fireSafety, _name:'Fire Safety', _mask:'Fire Safety'},
  {...all.immediateAttention, _name:'Immediate Attention', _mask:'Immediate Attention'},
  {...all.lifeSafety, _name:'Life Safety', _mask:'Life Safety'},
  {...all.pestManagement, _name:'Pest Management', _mask:'Pest Management'},
  {...all.sanitation, _name:'Sanitation', _mask:'Sanitation'},
  {...all.stairHazard, _name:'Stair Hazard', _mask:'Stair Hazard'},
  {...all.structural, _name:'Structural', _mask:'Structural'},
  {...all.tripAndFallHazard, _name:'Trip-and-Fall Hazard', _mask:'Trip-and-Fall Hazard'},
  {...all.waterConservation, _name:'Water Conservation', _mask:'Water Conservation'},
  {...all.waterIntrusion, _name:'Water Intrusion', _mask:'Water Intrusion'},

  {...all.vendor, _name: 'Vendor', _mask: 'Vendor', '!color': 'FF0000', '!rank': 1},
  {...all.buildingAwareness, _name: 'Building Awareness', _mask: 'Building Awareness', '!color': '32BF50', '!rank': 2},
  {...all.daily, _name: 'Daily', _mask: 'Daily', '!color': '95D6F1', '!rank': 3},
  {...all.weekly, _name: 'Weekly', _mask: 'Weekly', '!color': '95D6F1', '!rank': 4},
  {...all.monthly, _name: 'Monthly', _mask: 'Monthly', '!color': '299BCD', '!rank': 5},
  {...all.quarterly, _name: 'Quarterly', _mask: 'Quarterly', '!color': '299BCD', '!rank': 6},
  {...all.semiAnnual, _name: 'Semi-Annual', _mask: 'Semi-Annual', '!color': '299BCD', '!rank': 7},
  {...all.seasonal, _name: 'Seasonal', _mask: 'Seasonal', '!color': '299BCD', '!rank': 8},
  {...all.annual, _name: 'Annual', _mask: 'Annual', '!color': '0071BC', '!rank': 9},
  {...all.every2Years, _name: 'Every2Years', _mask: 'Every 2 Years', '!color': '0071BC', '!rank': 10},
  {...all.every5Years, _name: 'Every5Years', _mask: 'Every 5 Years', '!color': '0071BC', '!rank': 11},
  {...all.every10Years, _name: 'Every10Years', _mask: 'Every 10 Years', '!color': '0071BC', '!rank': 12},
]

export {reportIcons}
